import { Inventory } from '../types/inventory'
import { weightInputToDecimal, kgToPounds, poundsToKg } from './weightUtils'

export const weightValuesToDisplayValues = (inventoryRow: Inventory): Inventory => {
  return {
    ...inventoryRow,
    current_weight: weightInputToDecimal(kgToPounds(inventoryRow.current_weight / 1000)),
    initial_weight: weightInputToDecimal(kgToPounds(inventoryRow.initial_weight / 1000)),
    price: weightInputToDecimal(poundsToKg(inventoryRow.price || 0)),
  }
}

export const weightValuesToSaveValues = (inventoryRow: Inventory): Inventory => {
  return {
    ...inventoryRow,
    current_weight: poundsToKg(inventoryRow.current_weight) * 1000,
    initial_weight: poundsToKg(inventoryRow.initial_weight) * 1000,
    price: kgToPounds(inventoryRow.price || 0),
  }
}
